import type { NextApiRequest, NextApiResponse, NextApiHandler } from 'next'
import { createLogger } from 'shared-utils'

const logger = createLogger('api')

type CustomNextApiHandler<T extends unknown[]> = (
  req: Parameters<NextApiHandler>[0],
  res: Parameters<NextApiHandler>[1],
  ...args: T
) => ReturnType<NextApiHandler>

const EXCLUDED_PATHS = ['/api/auth']

export function handlerWithLogging<T extends unknown[]>(
  handler: CustomNextApiHandler<T>
): CustomNextApiHandler<T> {
  return (req: NextApiRequest, res: NextApiResponse, ...args: T) => {
    if (EXCLUDED_PATHS.some((p) => req.url?.startsWith(p))) {
      return handler(req, res, ...args)
    }

    logger.log('[REQ]', req.method, req.url, req.body)

    const originalJson = res.json.bind(res)
    res.json = (body: unknown) => {
      logger.log('[RES]', req.method, req.url, res.statusCode, body)
      return originalJson(body)
    }

    return handler(req, res, ...args)
  }
}
